function regexValidator(value: string, pattern: string) {
  return value ? (new RegExp(pattern)).test(value) : true;
}

export default regexValidator;
